export enum PurchaseOrderTabs {
    Active = 1,
    FullyReceived = 2,
    Closed = 3
}
